<template>
  <!-- 落地页saas -->
  <div class="semsaas">
    <!-- 头部banner+表单 -->
    <BannerForm
      title="免费试用"
      :pcBgImg="pcBgImg"
      :landingPageName="landingPageName"
      :showForm="!showScrollForm"
      :logoSrc="logoSrc"
      @msg="handleShowMsg"
      @setShowSuccessDialog="setShowSuccessDialog"
      setHeight="540"
    >
      <template slot="title">
        <div class="semsaas-title-content">
          <div class="one-line">电子合同SaaS服务平台</div>
          <div class="two-line">多端支持，即开即用</div>
        </div>
      </template>
      <template slot="desc">
        <div class="semsaas-desc">钉钉、微信、小程序、H5、PC、APP</div>
        <div class="semsaas-desc">与纸质合同具备同等法律效力</div>
        <div class="semsaas-desc">浙江省“最多跑一次”电子签指定供应商</div>
      </template>
    </BannerForm>
    <!-- banner下方信息 -->
    <div class="banner-bottom">
      <div class="content">
        <div class="item" v-for="(item, index) in bannerBottomData" :key="index">
          <div class="first-line-text">{{ item.firstLineText }}</div>
          <div class="second-line-text">{{ item.secondLineText }}</div>
        </div>
      </div>
    </div>
    <!-- e签宝SaaS产品套餐 -->
    <div class="product-package">
      <SectionCard :isPcFlag="true" title="e签宝SaaS产品套餐">
        <div class="package-title-content">
          <div class="package-center">
            <div class="package-item" v-for="item in packageTitleData" :key="item.key">
              <div class="title">{{ item.title }}</div>
              <div class="desc">{{ item.desc }}</div>
            </div>
          </div>
          <img class="connect-img" src="../../assets/images/sem-api/connect-one.png" alt="" />
        </div>
        <div class="remarks">合同计费方式：版本费+使用合同份数套餐计费，用量越大单价越低</div>
        <!-- 具体套餐 -->
        <div class="version">
          <div v-for="item in systemList" :key="item.title" class="version-item">
            <div class="top-img">
              <img :src="item.imgSrc" alt="不同产品版本" />
            </div>
            <div class="version-name">{{ item.title }}</div>

            <div class="btn-ask" @click="onBtnClick(item.buttonText)">
              {{ item.buttonText }}
            </div>
            <div class="desc">
              <p class="line1">{{ item.text1 }}</p>
              <p class="line22">{{ item.text2 }}</p>
              <p class="line33">{{ item.text3 }}</p>
            </div>
            <div class="kind">
              <div v-for="kid in item.kindList" :key="kid.text" class="kid-item">
                <img :src="kid.icon" style="margin-right: 0.3125vw" alt="小图标" />
                <span> {{ kid.text }}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="button-operation">
          <div>
            <div class="btn mfsy" @click="showDialog">免费试用</div>
            <div class="desc">注册可得5份合同试用</div>
          </div>
          <div>
            <div class="btn zxzx" @click="OnlineConsultationClick">在线咨询</div>
            <div class="desc">如需购买或了解更多套餐</div>
          </div>
        </div>
      </SectionCard>
    </div>
    <!-- 无需邮寄，1分钟完成线上签署 -->
    <div class="flow-path">
      <SectionCard :isPcFlag="true" title="无需邮寄，1分钟完成线上签署" :bgImg="flowPathBg">
        <div class="path-content">
          <div class="content">
            <div class="path-left">
              <div class="one-line">
                <div class="item" v-for="item in flowPathOneLine" :key="item.key">
                  <div class="item-content">
                    <img :src="item.imgSrc" alt="" />
                    <p>{{ item.text }}</p>
                  </div>
                  <img class="one-line-arrow" v-if="item.key !== 4" src="@/assets/images/sem-saas/flow-arrow.png" alt="" />
                </div>
              </div>
              <div class="two-line">
                <img class="two-line-arrow" src="@/assets/images/sem-saas/flow-arrow.png" alt="" />
              </div>
              <div class="three-line">
                <div class="item" v-for="item in flowPathTwoLine" :key="item.key">
                  <div class="item-content">
                    <img :src="item.imgSrc" alt="" />
                    <p>{{ item.text }}</p>
                  </div>
                  <img class="three-line-arrow" v-if="item.key !== 4" src="@/assets/images/sem-saas/flow-arrow.png" alt="" />
                </div>
              </div>
            </div>
            <div class="path-right">
              <img class="qr-img" src="https://www.esign.cn/upload/resources/image/2024/04/09/43148.png" alt="" />
              <p class="qr-desc">扫码免费领取5份试用</p>
            </div>
          </div>
        </div>
      </SectionCard>
    </div>
    <!-- 行业实践解决方案 -->
    <SolutionList class="solution-saas" :title="solutions.title" :solutionList="solutions.list" @showDialog="showDialog" />
    <!-- 安全可靠的电子合同服务 -->
    <div class="safe-reliable">
      <SectionCard :isPcFlag="true" title="安全可靠的电子合同服务" bgColor="#f7f7f9">
        <div class="content">
          <div class="card" v-for="(item, index) in safeReliableData" :key="index">
            <img :src="item.img" alt="" />
            <div class="title">{{ item.title }}</div>
            <div class="desc">{{ item.desc }}</div>
          </div>
        </div>
        <div class="btns-box">
          <div class="btns">
            <div class="mfsy" @click="showDialog">免费试用</div>
            <div class="zxzx" @click="OnlineConsultationClick">在线咨询</div>
          </div>
        </div>
      </SectionCard>
    </div>
    <!-- SaaS Ai -->
    <div class="saas-ai">
      <div class="saas-ai-content">
        <div class="title">SaaS平台AI能力升级 2023</div>
        <ul class="content">
          <li v-for="item in saasAiData" :key="item.key">
            <p>{{ item.desc }}</p>
          </li>
        </ul>
      </div>
    </div>
    <!-- 客户案例 -->
    <OrgList class="customer-cases" :title="orgList.title" :orgTypeList="orgList.orgTypeList" :imgs="orgList.imgs" />
    <!-- 底部备案信息 -->
    <FooterBasis />
    <!-- 左侧计算机小象 -->
    <LeftBar />
    <!-- 免费试用申请弹框 -->
    <UseDialog ref="dialog" :wlCode="true" />
    <!-- 右侧客服 -->
    <!--    <Contact :landingPageName="landingPageName" :saasApiContact="true" />-->
    <!-- 提示信息 -->
    <Message :type="message.type" :title="message.title" :content="message.content" :show.sync="message.show" />
    <!-- 提交完成弹框 -->
    <WeilingSuccessDialog :wlCode="true" v-if="showSuccessDialog" @closeform="showSuccessDialog = false" />
  </div>
</template>

<script>
import dataList from './dataList'
import qiyuMixin from '@/mixins/form/qiyu.js'
export default {
  name: 'semSaas',
  mixins: [qiyuMixin],
  components: {
    LeftBar: () => import('@/components/LeftBar/index.vue'),
    BannerForm: () => import('@/components/BannerForm.vue'),
    SectionCard: () => import('@/components/basics/SectionCard.vue'),
    SolutionList: () => import('@/views/extension/components/pc/SolutionList.vue'),
    OrgList: () => import('@/views/extension/components/pc/OrgList.vue'),
    UseDialog: () => import('@/components/UseDialog.vue'),
    Message: () => import('@/views/extension/components/pc/Message.vue'),
    // Contact: () => import('@/components/Contact.vue'),
    FooterBasis: () => import('@/components/FooterBasis.vue'),
    WeilingSuccessDialog: () => import('@/components/saasApiSuccessForm.vue'),
  },
  data() {
    return {
      logoSrc: require('@/assets/images/real-estate/logo.png'),
      pcBgImg: require('@/assets/images/sem-saas/banner-bg.png'),
      flowPathBg: require('@/assets/images/sem-saas/flow-path.png'),
      qrCodeImg: require('@/assets/images/sem-saas/flow-qr-code.png'),
      // 落地页名字'e签宝宣传'，因为以上的组件会被多次复用，为了服务商收集数据的时候能够更准确，用这个名字去判断是否需要向服务商发送数据
      landingPageName: 'esignPropagate',
      showScrollForm: false,
      showSuccessDialog: false,
      message: {
        type: '',
        title: '',
        content: '',
        show: false,
      },
      bannerBottomData: dataList.bannerBottomData,
      packageTitleData: dataList.packageTitleData,
      electronicCard: dataList.electronicCard,
      flowPathOneLine: dataList.flowPathOneLine,
      flowPathTwoLine: dataList.flowPathTwoLine,
      solutions: dataList.solutions,
      safeReliableData: dataList.safeReliableData,
      saasAiData: dataList.saasAiData,
      orgList: dataList.orgList,
      systemList: dataList.systemList,
    }
  },
  mounted() {
    window.addEventListener('scroll', this.scrollHandle, true)
    this.addQiyuScript()
  },
  computed: {
    qrCodeUrl() {
      return this.$store.state.user.wlQrcode || ''
    },
  },
  methods: {
    scrollHandle() {
      const scrollTop = document.documentElement.scrollTop || document.body.scrollTop // 滚动条偏移量
      this.showScrollForm = scrollTop >= 2280
    },
    showDialog() {
      this.$refs.dialog.showDialog()
    },
    OnlineConsultationClick() {
      this.handleNewBaiduService()
    },
    onBtnClick(type) {
      if (type === '在线咨询') this.handleNewBaiduService()
      if (type === '免费试用') this.showDialog()
    },
    setShowSuccessDialog(v) {
      this.showSuccessDialog = v
    },
    handleShowMsg({ type, title, content }) {
      this.message.type = type
      this.message.title = title
      this.message.content = content
      this.message.show = true
    },
  },
}
</script>

<style lang="less" scoped>
@import './style.less';
</style>
